import * as PropTypes from 'prop-types';
import * as React from 'react';
import UrlHelpers from '../../../shared/url_helpers';
import PriceSearchPills from './price_search_pills';
import CategorySearchPill from './category_search_pill';
import BrandSearchPills from './brand_search_pills';
import OperatingSystemSearchPill from './operating_system_search_pill';
import FileTypeSearchPills from './file_type_search_pills';

function operatingSystemTraitValue(indexParams, operatingSystem) {
  const osSlug = indexParams.operatingSystem;
  if (!osSlug) { return null; }

  return operatingSystem.findValueBySlug(osSlug);
}

const SearchPills = ({
  indexParams, operatingSystem, fileType, category,
}) =>
  (<ul className="collection-search-results inline">
    <li className="category-filter filter-term">
      {I18n.t('digitalListing.softwareCategoryName')}
      <a className="ml-half filter-term-remove" rel="nofollow" href={UrlHelpers.rootPath}>
        <span className="fa fa-times" />
      </a>
    </li>
    <CategorySearchPill category={category} />
    <BrandSearchPills
      brands={indexParams.brand}
      changeBrands={brands => indexParams.changeBrands(brands)}
    />
    <OperatingSystemSearchPill
      traitValue={operatingSystemTraitValue(indexParams, operatingSystem)}
      changeOperatingSystem={os => indexParams.changeOperatingSystem(os)}
    />
    <FileTypeSearchPills
      fileType={fileType}
      fileTypes={indexParams.fileTypes}
      changeFileTypes={fileTypes => indexParams.changeFileTypes(fileTypes)}
    />
    <PriceSearchPills
      indexParams={indexParams}
    />
  </ul>);

SearchPills.propTypes = {
  indexParams: PropTypes.object.isRequired,
  operatingSystem: PropTypes.object.isRequired,
  fileType: PropTypes.object.isRequired,
  category: PropTypes.object,
};

export default SearchPills;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/search_pills/search_pills.jsx